const reasonCodes = [
    {
        value: 'AF',
        name: 'Accident',
        localizationSlug: 'ACCIDENT',
    },
    {
        value: 'D1',
        name: 'Carrier Dispatch Error',
        localizationSlug: 'CARRIER_DISPATCH_ERROR',
    },
    {
        value: 'BF',
        name: 'Carrier Keying Error',
        localizationSlug: 'CARRIER_KEYING_ERROR',
    },
    {
        value: 'B1',
        name: 'Consignee Closed',
        localizationSlug: 'CONSIGNEE_CLOSED',
    },
    {
        value: 'S1',
        name: 'Delivery Shortage',
        localizationSlug: 'DELIVERY_SHORTAGE',
    },
    {
        value: 'AH',
        name: 'Driver Related',
        localizationSlug: 'DRIVER_RELATED',
    },
    {
        value: 'BL',
        name: 'Held for Protective Service',
        localizationSlug: 'HELD_PROTECTIVE_SERVICE',
    },
    {
        value: 'BB',
        name: 'Held per Shipper',
        localizationSlug: 'HELD_PER_SHIPPER',
    },
    {
        value: 'B8',
        name: 'Improper Unloading Facility or Equipment',
        localizationSlug: 'IMPROPER_UNLOADING_FACILITY',
    },
    {
        value: 'A2',
        name: 'Incorrect Address',
        localizationSlug: 'INCORRECT_ADDRESS',
    },
    {
        value: 'T7',
        name: 'Insufficient Delivery Time',
        localizationSlug: 'INSUFFICIENT_DELIVERY_TIME',
    },
    {
        value: 'BP',
        name: 'Load Shifted',
        localizationSlug: 'LOAD_SHIFTED',
    },
    {
        value: 'AI',
        name: 'Mechanical Breakdown',
        localizationSlug: 'MECHANICAL_BREAKDOWN',
    },
    {
        value: 'BC',
        name: 'Missing Documents',
        localizationSlug: 'MISSING_DOCUMENTS',
    },
    {
        value: 'NA',
        name: 'Normal Appointment',
        localizationSlug: 'NORMAL_APPOINTMENT',
    },
    {
        value: 'BG',
        name: 'Other (Early)',
        localizationSlug: 'OTHER_EARLY',
    },
    {
        value: 'BO',
        name: 'Railroad Failed to Meet Schedule',
        localizationSlug: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    },
    {
        value: 'RC',
        name: 'Re-Consigned',
        localizationSlug: 'RECONSIGNED',
    },
    {
        value: 'B9',
        name: 'Receiving Time Restricted',
        localizationSlug: 'RECEIVING_TIME_RESTRICTED',
    },
    {
        value: 'BS',
        name: 'Refused by Customer',
        localizationSlug: 'REFUSED_BY_CUSTOMER',
    },
    {
        value: 'BT',
        name: 'Returned to Shipper',
        localizationSlug: 'RETURNED_TO_SHIPPER',
    },
    {
        value: 'BE',
        name: 'Road Conditions',
        localizationSlug: 'ROAD_CONDITIONS',
    },
    {
        value: 'BQ',
        name: 'Shipment Overweight',
        localizationSlug: 'SHIPMENT_OVERWEIGHT',
    },
    {
        value: 'AM',
        name: 'Shipper Related',
        localizationSlug: 'SHIPPER_RELATED',
    },
    {
        value: 'T2',
        name: 'Tractor, Conventional, Not Available',
        localizationSlug: 'TRACTOR_CONVENTIONAL_NA',
    },
    {
        value: 'T3',
        name: 'Trailer not Available',
        localizationSlug: 'TRAILER_NA',
    },
    {
        value: 'T4',
        name: 'Trailer Not Usable Due to Prior Product',
        localizationSlug: 'TRAILER_NOT_USABLE',
    },
    {
        value: 'AT',
        name: 'Unable to Contact Recipient for Broker Information',
        localizationSlug: 'UNABLE_CONTACT_RECIPIENT',
    },
    {
        value: 'A5',
        name: 'Unable to Locate',
        localizationSlug: 'UNABLE_TO_LOCATE',
    },
    {
        value: 'AO',
        name: 'Weather or Natural Disaster Related',
        localizationSlug: 'WEATHER_NATURAL_DISASTER',
    },
    {
        value: 'BG-1',
        display: 'OD - Normal Delivery',
        localizationSlug: 'NORMAL_DELIVERY',
        name: 'Normal Delivery',
    },
    {
        value: 'AJ-1',
        display: 'OD - Delivered on Manifest',
        name: 'Delivered on Manifest',
        localizationSlug: 'DELIVERED_ON_MANIFEST',
    },
    {
        value: 'AG-1',
        display: 'OD - Driver Release',
        name: 'Driver Release',
        localizationSlug: 'DRIVER_RELEASE',
    },
];
export const REASON_CODES = {
    rate_error: 'RATE_ERROR',
    fuel_error: 'FUEL_ERROR',
    btf_error: 'BTF_ERROR',
    accessorial_error: 'ACCESSORIAL_ERROR',
    customer_accommodation: 'CUSTOMER_ACCOMODATION',
    missing_documentation: 'MISSING_DOCUMENTATION',
    missing_approvals: 'MISSING_APPROVALS',
    duplicate_invoice: 'DUPLICATE_INVOICE',
};
export default reasonCodes;
